<!--
@Author: Caroline
@Desc: 关于我们
@Date: 2021-04-22 11时
-->
<template>
  <div class="page-main">
    <!-- banner -->
    <div class="about-banner">
      <div class="banner-text">
        <p>场景化灵活用工服务平台</p>
        <p>用科技赋能数字化就业与协同治理</p>
      </div>
    </div>

    <!-- tab  -->
    <div class="tab-part">
      <transition-group tag="ul" name="slide" class="min-width-pc tab-content">
        <!-- <ul class="min-width-pc tab-content"> -->
        <li
          :class="item.className"
          @click="clickTab(item)"
          v-for="item in tabList"
          :key="item.id"
        >
          <img :src="item.imgUrl" alt="" width="40px" height="40px" />
          <span>{{ item.tabName }}</span>
        </li>
        <!-- </ul> -->
      </transition-group>
    </div>

    <!-- 了解我们 -->
    <div v-show="activeItemId == '1'">
      <!-- 简介 -->
      <div class="title-txt">慧用工简介</div>
      <div class="min-width-pc company-introduce">
        <p>慧用工成立于2019年2月，是一家场景化灵活用工服务平台。</p>
        <br />
        <p>
          慧用工致力于灵活用工领域，致于服务2亿灵活用工从业者。目前为全国共享经济业态企业提供新经济灵活用工招募、用工管理、用工结算等全链条灵活用工服务。基于对不同垂直细分行业的深耕，已经为保险、电商、货运等垂直行业提供场景化解决方案和增值服务。经过一年的发展，慧用工构建了覆盖全国范围的自营团队+服务商网络，服务覆盖40余个细分行业10000余家企业客户，数百万自由职业者。
        </p>
        <br />
        <p>
          慧用工作为承载新个体经济健康发展的新经济平台，将继续创新，以互联网技术为依托促进更多自由职业者多渠道就业创业，为稳就业保民生贡献力量。在做好灵活用工平台的同时，将积极探索新业态新模式下的发展道路，发展共享经济，为我国的新经济发展做出贡献。
        </p>
      </div>

      <!-- 分割图 -->
      <div class="about-bg-img"></div>

      <!-- 发展历程 -->
      <div class="title-txt">发展历程</div>
      <div class="min-width-pc history-part">
        <!-- 2019年 -->

        <div
          class="history-content"
          v-for="(item, index) in historyList"
          :key="index"
          v-show="activeHistoryId == item.id"
        >
          <span
            class="content-year"
            v-if="activeHistoryId != historyList.length"
            >{{ item.year }}</span
          >
          <div
            class="content-month-txt"
            v-if="activeHistoryId != historyList.length"
          >
            <p v-for="(itemSon, indexSon) in item.list" :key="indexSon">
              <span class="mon-num">{{ itemSon.monthText }}</span>
              <span>{{ itemSon.content }}</span>
            </p>
          </div>

          <!-- 未来 -->
          <div class=" last-content" v-else>
            <div class="content-month-txt">
              <span>未来，世界很大，一起灵活用工</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 时间轴 -->
      <div class="min-width-pc">
        <div class="time-line">
          <div
            :class="history.className"
            @click="clickTimePoint(history)"
            v-for="history in historyList"
            :key="history.id"
          >
            <span class="line" :class="history.isActive && 'activeLine'"></span>
            <span class="circle"></span>
            <span class="year-txt">{{ history.year }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div v-show="activeItemId == '2'">
      <div class="title-txt">办公地点</div>
      <div class="map-bg">
        <div
          class="address-item"
          v-for="(item, index) in addressList"
          :key="index"
        >
          <img :src="item.imgUrl" alt="office-address" />
          <p class="city">{{ item.city }}</p>
          <p v-html="item.addrDetail"></p>
        </div>
      </div>

      <div class="emai-tel-part">
        <img src="../../../static/pc/img_left@2x.png" alt="" />
        <div class="ways-div">
          <div class="way-item">
            <!-- <img
              src="../../../static/pc/about/aboutus_icon_tel@2x_border.png"
              alt=""
            /> -->
            <p>咨询热线</p>
            <p>400-085-5500</p>
          </div>

          <div class="way-item">
            <!-- <img
              src="../../../static/pc/about/aboutus_icon_mail_border.png"
              alt=""
            /> -->
            <p>联系邮箱</p>
            <p>market@hvyogo.com</p>
          </div>
        </div>

        <img src="../../../static/pc/img_right@2x.png" alt="" />
      </div>

      <!-- <div class="fullwidth-bg-img contact-ways">
        <div class="way-item">
          <img
            src="../../../static/pc/about/aboutus_icon_tel@2x_border.png"
            alt=""
          />
          <div class="way-text">
            <span>咨询热线</span> <br />
            <span>400-085-5500</span>
          </div>
        </div>

        <div class="way-item">
          <img
            src="../../../static/pc/about/aboutus_icon_mail_border.png"
            alt=""
          />
          <div class="way-text">
            <span>联系邮箱</span> <br />
            <span>market@hvyogo.com</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- 加入我们 -->
    <div v-show="activeItemId == '3'" id="postsDiv">
      <div class="title-txt">社会招聘</div>
      <div class="min-width-pc ">
        <!-- 研发职位 -->
        <div class="post-part">
          <img
            src="../../../static/pc/about/aboutus_icon_position_1@2x.png"
            alt=""
          />
          <div class="post-box">
            <el-collapse accordion v-model="activeNames" @change="handleChange">
              <el-collapse-item
                class="post-item"
                v-for="(item, index) in devPostsList"
                :name="item.id"
                :key="index"
              >
                <template slot="title">
                  <span class="title-text">{{ item.postName }}</span>
                </template>
                <div class="post-desc-text">
                  <div class="text" v-html="item.postDesc"></div>
                  <div class="text last-text" v-html="item.postRequire"></div>
                  <div class="btnFullColor">投递邮箱：geyaru@hvyogo.com</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>

        <!-- 市场 & 营销职位 -->
        <div class="post-part">
          <img
            src="../../../static/pc/about/aboutus_icon_position_2@2x.png"
            alt=""
          />
          <div class="post-box">
            <el-collapse
              accordion
              v-model="activeNameMarket"
              @change="handleChangeMarket"
            >
              <el-collapse-item
                class="post-item"
                v-for="(item, index) in marketPostsList"
                :name="item.id"
                :key="index"
              >
                <template slot="title">
                  <span class="title-text">{{ item.postName }}</span>
                </template>
                <div class="post-desc-text">
                  <div class="text" v-html="item.postDesc"></div>
                  <div class="text last-text" v-html="item.postRequire"></div>
                  <div class="btnFullColor ">投递邮箱：geyaru@hvyogo.com</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>

        <!-- 底部信息 -->
        <div class="hr-email-part">
          <div class="email-content">
            <p>简历发至招聘邮箱：geyaru@hvyogo.com</p>
            <p>HR团队将在收到简历的5个工作日内进行处理。</p>
            <p>若简历通过，您将立即收到通知。</p>
          </div>

          <img
            src="../../../static/pc/about/aboutus_icon_mail@2x.png"
            alt="email"
          />
        </div>
      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source="source"
      ><span class="pc-form-text"
        >慧用工｜致力于助力每一个优秀的公司</span
      ></pc-form-dialog
    >
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
  </div>
</template>

<script type="text/javascript">
import { checkNull, setSession, getSession } from "../../filters/filters";
import pcFormDialog from "../../components/pcFormDialog.vue";
import {
  PC_ABOUT_TAB_LIST,
  PC_ABOUT_HISTORY_LIST,
  PC_ABOUT_ADDRESS_LIST,
  PC_ABOUT_DEV_POSTS_LIST,
  PC_ABOUT_MARKET_POSTS_LIST
} from "../../service/businessConsts";
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  name: "about-user",
  data() {
    return {
      tabList: PC_ABOUT_TAB_LIST,
      historyList: PC_ABOUT_HISTORY_LIST,
      addressList: PC_ABOUT_ADDRESS_LIST,
      devPostsList: PC_ABOUT_DEV_POSTS_LIST,
      marketPostsList: PC_ABOUT_MARKET_POSTS_LIST,
      activeItemId: "1", // tab选中id， 默认tab为1
      activeHistoryId: "5", // 发展历程列表选中id
      activeNames: [], // 研发职位列表选中id
      activeNameMarket: [], // 销售职位列表选中id
      scrollTop: 0,
      source: "",
      sourceF: ""
    };
  },
  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  created() {
    console.log("tab active id：", getSession("aboutTabId"));
    if (checkNull(getSession("aboutTabId"))) {
      this.activeItemId = "1"; // 默认tab为1
    } else {
      this.activeItemId = getSession("aboutTabId");
    }
    for (let tab of this.tabList) {
      tab.className = "tab-item";
      tab.imgUrl = tab.imgUrl.replace("light", "black");
      if (tab.id == this.activeItemId) {
        tab.className = "tab-item active";
        tab.imgUrl = tab.imgUrl.replace("black", "light");
      }
    }

    // source来源：：
    let hash = window.location.hash;
    this.source =
      hash.indexOf("source") > 0
        ? hash.substring(hash.indexOf("source")) + "&pageFrom=gywm"
        : "&pageFrom=gywm";
    this.sourceF = this.source + "_f";
  },

  mounted() {
    window.addEventListener("scroll", this.handleScrollTop);
  },
  methods: {
    // 时间轴切换年份
    clickTimePoint(item) {
      for (let tab of this.historyList) {
        tab.className = "time-point";
        tab.isActive = false;
      }
      item.className = "time-point active-point-time";
      item.isActive = true;
      this.activeHistoryId = item.id;
      console.log("History id====", this.activeHistoryId);
    },

    // 查看研发职位
    handleChange(val) {
      console.log("研发职位：", val); // name
      for (let item of this.marketPostsList) {
        item.isDeliver = false;
      }
      this.activeNameMarket = [];
    },

    // 查看市场营销职位
    handleChangeMarket(val) {
      console.log("市场职位：", val); // name
      for (let item of this.devPostsList) {
        item.isDeliver = false;
      }
      this.activeNames = [];

      if (val == 1 && this.scrollTop > 1000) {
        //  滚动到销售总监时，页面回滚到800的位置
        document.documentElement.scrollTop = 800;
        console.log("1滚了吗？", document.documentElement.scrollTop);
      }
      if (val == 2 && this.scrollTop > 1400) {
        // 滚动到大客户销售经理时，页面回滚到1000的位置
        document.documentElement.scrollTop = 1000;
        console.log("2滚了吗？", document.documentElement.scrollTop);
      }
    },

    // scrollTop
    handleScrollTop() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(this.scrollTop)
    },

    // tab切换
    clickTab(item) {
      for (let tab of this.tabList) {
        tab.className = "tab-item";
        tab.imgUrl = tab.imgUrl.replace("light", "black");
      }
      item.className = "tab-item active";
      item.imgUrl = item.imgUrl.replace("black", "light");
      this.activeItemId = item.id;
      console.log("tab id====", this.activeItemId);
      setSession("aboutTabId", this.activeItemId);
    }
  }
};
</script>

<style lang="scss">
#postsDiv {
  // 招聘 折叠效果
  .post-box {
    .el-collapse {
      border-top: 1px solid #cfcfcf;
    }
  }

  .el-collapse-item.post-item.is-active {
    // 打开职位背景修改
    background-color: #f4f4f4;
    .el-collapse-item__wrap {
      background-color: #f4f4f4;
    }
  }

  .el-collapse-item {
    .el-collapse-item__header {
      border-bottom: 1px solid #cfcfcf; // 修改emel原有border
      background-color: #fbfdff;
      min-height: 125px;
      .title-text {
        margin-left: 35px;
      }

      span {
        font-size: 24px;
        color: #100f0f;
        display: inline-block;
      }
      .el-collapse-item__arrow.el-icon-arrow-right {
        margin-right: 35px;
        color: #100f0f;
        font-size: 22px;
      }
    }

    .el-collapse-item__header.is-active {
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0); // 职位标题下方默认的border去掉
      background-color: #f4f4f4; // 打开职位背景修改
    }

    .el-collapse-item__wrap {
      margin-top: 20px; // 职位描述 top值
      border-bottom: 1px solid #cfcfcf;
      text-align: left;
      background-color: #fbfdff;

      .el-collapse-item__content {
        // 投递按钮底部padding值修改
        padding-bottom: 48px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.page-main {
  .about-banner {
    // banner
    width: 100%;
    height: 720px;
    background: url("../../../static/pc/about/banner_aboutus_1@1x.png")
      no-repeat top center;
    background-size: cover;
    background-color: #111010;

    .banner-text {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      p:first-child {
        font-weight: bold;
        font-size: 50px;
      }
      p:last-child {
        font-size: 18px;
        margin-top: 14px;
      }
    }
  }

  .emai-tel-part {
    width: 100%;
    min-width: 1300px;
    height: 300px;
    background: url("../../../static/pc/about/img_bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    img {
      width: 312px;
      height: 300px;
    }

    .ways-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 670px;
      justify-content: space-between;
      .way-item {
        text-align: left;
        color: #fff;
        font-size: 24px;
        width: 265px;
        img {
          width: 60px;
          height: 60px;
        }
        p:last-child {
          font-size: 36px;
        }
        &:last-child {
          width: 375px;
        }
      }
    }
  }

  .title-txt {
    // 标题
    margin: 88px 0 77px 0;
  }

  .tab-part {
    // 顶部tab
    width: 100%;
    padding: 20px 0;
    background-color: rgba($color: #1985ff, $alpha: 0.05);

    .tab-content {
      height: 60px;
      display: inline-block;
      text-align: left;
    }

    .tab-item {
      width: 33.33%; // 1200px
      box-sizing: border-box;
      height: 60px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #171e2e;
      font-size: 18px;
      border-left: 1px solid #cfcfcf;
      cursor: pointer;
      img {
        margin-right: 14px;
      }
      &:last-child {
        border-right: 1px solid #cfcfcf;
      }
      transition: all 0.8s;
    }

    .active {
      color: #1985ff;
    }
  }

  .company-introduce {
    // 公司简介
    text-align: left;
    margin-bottom: 74px;
    color: #171e2e;
    font-size: 18px;
    text-align: justify;
  }

  .about-bg-img {
    // 分割banner
    background: url("../../../static/pc/about/aboutus_img@1x.png") no-repeat top
      center;
    background-size: cover;
    background-color: #111010;
    width: 100%;
    height: 300px;
  }

  .history-part {
    // 发展历程文案
    height: 330px;
    border-bottom: 1px solid #cfcfcf;
    background-image: linear-gradient(
      180deg,
      rgba(25, 133, 255, 0.05) 0%,
      rgba(255, 255, 255, 0) 100%
    );

    .history-content {
      text-align: left;
      padding: 26px 0 0 145px;
      display: flex;
      justify-content: flex-start;

      .content-year {
        font-family: AlibabaPuHuiTi-Medium;
        display: inline-block;
        margin-top: 20px;
        color: #171e2e;
        font-size: 36px;
        -ms-transform: rotate(90deg); /* IE 9 */
        transform: rotate(90deg); /* 标准语法 */
        -webkit-transform: rotate(90deg);
        width: 90px;
        height: 50px;
      }

      .content-month-txt {
        display: inline-block;
        color: #171e2e;
        font-size: 18px;
        p {
          margin-bottom: 18px;
        }
        .mon-num {
          color: #1985ff;
          display: inline-block;
          width: 40px;
          text-align: right;
        }
      }

      .last-content {
        text-align: center;
        display: flex;
        padding-left: 100px;
        justify-content: center;
        .content-month-txt {
          margin-top: 100px;
          color: #171e2e;
          font-size: 50px;
        }
      }
    }
  }

  .time-line {
    // 发展历程时间轴
    padding: 0 145px;
    margin-bottom: 88px;
    display: flex;
    justify-content: space-between;
    .time-point {
      width: 45px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: -72px;
      cursor: pointer;
      .line {
        display: block;
        display: inline-block;
        width: 1px;
        height: 60px;
        background-color: rgba($color: #1985ff, $alpha: 0);
      }
      .activeLine {
        background-color: #1985ff;
      }

      .year-txt {
        color: #403f3f;
      }

      .circle {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 100%;
        border: 1px solid #cfcfcf;
        margin-bottom: 15px;
      }
    }

    .active-point-time {
      .circle {
        border: 1px solid #1985ff;
      }
      .year-txt {
        color: #1985ff;
      }
    }
  }

  .map-bg {
    // 办公地点
    background: url("../../../static/pc/about/bg_about_map.png") no-repeat
      bottom center;
    background-size: 100%;
    width: 1220px;
    margin: 0 auto;
    margin-bottom: 68px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .address-item {
      width: 285px;
      height: 390px;
      margin: 20px 0 0 20px;
      box-shadow: 0 20px 60px -10px rgba(25, 133, 255, 0.1);
      border-radius: 8px;
      background-color: #fff;
      cursor: pointer;
      &:nth-child(4) {
        margin-right: 0;
      }
      img {
        width: 100%;
        margin-bottom: 30px;
      }
      p {
        margin: 0 auto;
        font-size: 18px;
        color: #100f0f;
        white-space: pre-wrap;
        padding: 0 24px;
        box-sizing: border-box;
      }
      p.city {
        // font-family: AlibabaPuHuiTiM;
        margin-bottom: 16px;
        font-weight: blod;
      }

      &:hover {
        position: relative;
        top: -5px;
        box-shadow: 0 20px 20px 0px rgba(16, 15, 15, 0.09);
      }
    }
  }

  // .contact-ways {
  //   // 400电话和邮箱部分
  //   margin: 0 auto;

  //   .way-item {
  //     display: inline-flex;
  //     align-items: center;
  //     color: #fff;
  //     font-size: 24px;
  //     margin-top: 100px;
  //     img {
  //       width: 60px;
  //       height: 60px;
  //     }
  //     .way-text {
  //       text-align: left;
  //       margin-left: 24px;
  //       span:last-child {
  //         font-size: 36px;
  //       }
  //     }
  //     &:last-child {
  //       margin-left: 180px;
  //     }
  //   }
  // }

  .post-part {
    // 社会招聘部分
    display: flex;
    justify-content: flex-end;
    margin-bottom: 87px;
    .post-box {
      width: 795px;

      .post-item {
        .post-desc-text {
          margin: 0 35px;
          div.text {
            white-space: pre-wrap; // 解决v-html指令解析文本后，换行丢失的问题
            font-size: 18px;
            color: #171e2e;
          }
          div.last-text {
            margin-top: 48px;
          }
          .btnFullColor {
            margin-top: 48px;
            width: 320px;
          }
        }
      }
    }
    img {
      width: 138px;
      height: 138px;
      margin-right: 135px;
    }
  }

  .hr-email-part {
    width: 100%;
    height: 220px;
    margin-bottom: 87px;
    background-image: linear-gradient(
      180deg,
      rgba(25, 133, 255, 0.05) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    padding: 0 125px 0 105px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .email-content {
      text-align: left;
      font-family: AlibabaPuHuiTiR;
      font-size: 18px;
      color: #9f9f9f;
      line-height: 36px;
      p:first-child {
        font-size: 24px;
        color: #100f0f;
        margin-bottom: 18px;
      }
    }

    img {
      width: 202px;
      height: 202px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/aboutUser.vue